enum Season {
  // 2/16 - 6/30
  Spring = 'Spring',
  // 7/1 - 11/15
  Fall = 'Fall',
  // 11/16 - 2/15
  Winter = 'Winter'
}

export default Season;
